import type { CSSProperties, FC } from "react";
import logo from "../../../assets/wixar-logo.jpg";

const WixarLogo3: FC<{ style?: CSSProperties }> = (props) => {
  return <img src={logo} alt="Wixar" style={props.style} />;
};

export default WixarLogo3;
